// extracted by mini-css-extract-plugin
module.exports = {"container":"RotateDevice_container__lZ0EW","phone":"RotateDevice_phone__2jsfO","rotate":"RotateDevice_rotate__uLv5r","message":"RotateDevice_message__3vHQ0"};